import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../core/useAuth';
import { AUTH_MODES } from '../core/authModes';
import { KeycloakLogin } from '../methods/keycloak/KeycloakLogin';
/*
 * FIXME/OPENISSUE/TODO
 * Does the simulated login conflict with the auth plugin?
 */
import { SimulatedLogin } from '../methods/simulated/SimulatedLogin';

export const LoginPage = () => {
  const { authMode, isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const returnTo = location.state?.returnTo || '/dashboard/hosting';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(returnTo, { replace: true });
    }
  }, [isAuthenticated, navigate, returnTo]);

  if (authMode === AUTH_MODES.SIMULATED) {
    return <SimulatedLogin />;
  }

  return <KeycloakLogin />;
};
